import { PickList } from '@krp/ui-kit'
import { rosterStatus } from '../model/rosterStatus'
import type { CashierAccessSummaryItem, SourceCashier } from '../model/types'

export interface CashierRosterProps {
  cashiers: SourceCashier[]
  /** Сводка входа по кассирам источника (RP-CT3); пока её нет, строки без статуса. */
  summary: CashierAccessSummaryItem[] | undefined
  resourceId: string
  search: string
  selectedKey: string
  selectedSourceCashierId?: string
  busy: boolean
  loading: boolean
  find: (search: string) => void
  choose: (cashierKey: string, sourceCashierId?: string) => void
}
/** Поиск и список кассиров выбранного источника (общий `PickList`). */
export function CashierRoster(props: CashierRosterProps) {
  const here = props.cashiers.filter((cashier) => cashier.resourceId === props.resourceId)
  const idOf = (cashier: SourceCashier) => cashier.sourceCashierId ?? cashier.key
  const statusOf = (cashier: SourceCashier) => rosterStatus(props.summary?.find((item) => cashier.sourceCashierId ? item.sourceCashierId === cashier.sourceCashierId : item.key === cashier.key))
  const items = here.map((cashier) => {
    const status = statusOf(cashier)
    const note = cashier.ambiguous === true ? (cashier.sourceCashierId ? `Для РМК · ID …${cashier.sourceCashierId.slice(-8)}` : 'Неоднозначная запись кассира') : cashier.directoryEntry !== true ? 'Нет записи в справочнике источника' : cashier.resourceName
    return { id: idOf(cashier), label: cashier.name, note: status === null ? note : `${note} · ${status}`,
      disabled: props.busy || (cashier.ambiguous === true && !cashier.sourceCashierId) || cashier.directoryEntry !== true }
  })
  const current = here.find((cashier) => props.selectedSourceCashierId ? cashier.sourceCashierId === props.selectedSourceCashierId : cashier.key === props.selectedKey)
  const selected = current === undefined ? undefined : idOf(current)
  return <div className="cashiers-roster">
    <PickList searchLabel="Найти кассира" listLabel="Кассиры источника" busy={props.loading} items={items} {...(selected === undefined ? {} : { selectedId: selected })}
      query={props.search} onQuery={props.find} emptyText="Кассиры не найдены." notFoundText="Кассиры не найдены."
      onPick={(id) => { const cashier = here.find((item) => idOf(item) === id); if (cashier !== undefined) props.choose(cashier.key, cashier.sourceCashierId ?? undefined) }} />
  </div>
}
